import "./AppErrorBoundary.scss";

import { FC } from "react";

import Button from "components/Button/Button";
import Icon from "components/Icon/Icon";
import Text from "components/Text/Text";
import Container from "containers/Container/Container";
import { useTranslation } from "modules";

interface IProps {
  onClick: () => void;
}

const AppErrorFallback: FC<IProps> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Container className="app-error-fallback__container">
      <div className="app-error-fallback__wrapper">
        <Icon className="app-error-fallback__icon" size="xl" src="BlobAlert" />
        <Text
          className="app-error-fallback__header"
          tag="h4"
          text={t("blocked.system_error.title", "Oops! We must've moved whatever was here")}
        />
        <Text
          className="app-error-fallback__subheader"
          tag="p3"
          text={t(
            "blocked.system_error.body",
            "Let's get you back on track and pretend this never happened."
          )}
        />
        <Button
          className="app-error-fallback__cta"
          dataTestId="app-error-cta"
          onClick={onClick}
          text={t("blocked.system_error.button", "FORGET YOU SAW THIS")}
        />
      </div>
    </Container>
  );
};

export default AppErrorFallback;
